<template>
  <div>
    <div class="cantainer">
      <my-tab1 :title="title"></my-tab1>
      <img :src="bj" alt="" class="cantainer-img">
      <div class="content ">
        <my-tab2 :is-list="false" class="left top"></my-tab2>
        <my-Content style="margin-left: 40px" class="right top bottom"></my-Content>
      </div>
    </div>
    <my-end></my-end>
  </div>
</template>
<script>
import Tab1 from '@/components/tabs/tabs1'
import Tab2 from '@/components/tabs/tabs2'
import End from '@/components/End'
import Content from '@/components/Content'
import dian from '@/assets/bj.jpeg'
import axios from "axios";
import {orgId, requestUrl} from "../common/cons";
export default {
  name: "NewsContent",
  components:{
    'my-tab1':Tab1,
    'my-tab2':Tab2,
    'my-end':End,
    'my-Content':Content
  },
  data(){
    return{
      bj:dian,
      title:[]
    }
  },
  created() {
    this.init()
  },
  methods:{
    async init () {
      await this.queryNavList()
    },
    async queryNavList(){
      const result = await axios.get(`${requestUrl}/nav/${orgId}`)
      this.title=result.data
    }
  }
}
</script>

<style scoped>

.cantainer{
width: 100%;
  display: flex;
  flex-direction: column;
  background-color:#EFFBEF ;
}
.top{
  margin-top: 20px;
}
.bottom{
  margin-bottom: 20px;
}
.left{
  margin-left: 40px;
}
.right{
  margin-right: 40px;
}
.cantainer-img{
  width: 100%;
  height: 180px;
}
.content{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/view/NewsContent.vue